export const COOKIE_CHANGED = '@@CookieObserver::CookieChanged';
